/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {
  useState, useEffect, useMemo, useRef,
} from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import styled from '@emotion/styled';
import { VariableSizeList as List } from 'react-window';
import { Field } from 'formik';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import Input from '../../../../shared/_TBComponents/Input/index';
import VideoAndUrlInput from './VideoAndUrlInputs';
import SelectBox from '../../../../shared/_TBComponents/SelectBox/index';
import { createTagForAccount } from '../../ducks/calendarActions';
import TBportalTooltip from '../../../../shared/components/TBportalTooltip';
import { showErrorToast } from '../../../../shared/utils/toastManager';

const DescriptionContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

const LiftInputsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const AdditionalOptionsHeaderRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const AdditionalOptionsTextAndArrowIconContainer = styled('div')`
 display: flex;
 align-items: center;
 cursor: pointer;
 gap: 8px;
 transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const Seperator = styled('div')`
  display: flex;
  width: 100%;
  height: 1px;
  background: #EEEEEE;
`;

const LiftInputsRow = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 528 ? 'column' : 'row')};
  gap: 32px;
`;

const LiftInputsSubContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

const LinkContainer = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 755 ? 'column' : 'row')};
  gap: 16px;
`;

const OuterLinkContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

const UpdateLinkedMaxContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  .checkbox-input {
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid #E0E0E0;
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    position: relative;
    transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
  }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: solid #E0E0E0;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }
`;

const StyledTextArea = styled('textarea')`
  width: 100%;
  height: 82px;
  max-height: 82px !important;
  min-height: 82px !important;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: 'Nunito Sans';
  color: #444444;
  &:focus {
    outline: none;
    border-color: #ccc;
    box-shadow: none;
  }
  ::placeholder {
    color: #9E9E9E;
  }

  :disabled {
    background: white;
    border-color: #EEEEEE;
    color: #BDBDBD;
  }
`;

const NameAndInputContainer = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  .checkbox-input {
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid #E0E0E0;
    border-radius: 4px;
    outline: none;
    cursor: ${(props) => (props.cursorNotAllowed ? 'not-allowed' : 'pointer')};
    position: relative;
    transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
  }

  .checkbox-input:checked {
    border: ${(props) => (props.disabled ? '2px solid #E0E0E0' : '2px solid #77A7FF')};
   }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: ${(props) => (props.disabled ? 'solid #E0E0E0' : 'solid #77A7FF')};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }
`;

const CheckBoxRow = styled('div')`
 display: flex;
 flex-wrap: wrap;
 gap: 16px;
`;

const LabelAndCheckBoxContainerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AdditionalOptionsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: -9px;
  transition: ${TransitionGlobal};
  overflow: hidden;
  max-height: ${(props) => (!props.showAdditionalOptions ? '0px' : '500px')};
`;

const LiftFormInputs = ({
  errors,
  touched,
  handleChange,
  videoUrlValue,
  mediaUrlValue,
  trackingValue,
  linkToValue,
  linkPercentageValue,
  updateLinkedExerciseMaxValue,
  tagsValue,
  setFieldValue,
  handleBlur,
  setFieldTouched,
  setFieldError,
  urlButtonValue,
  containerWidth,
  completionOnlyValue,
  coachCompletionValue,
  boadyWeightLiftValue,
  trackVolumeLoadValue,
  trackRepCountValue,
  barSpeedValue,
  eachSideValue,
  peakPowerValue,
  setTouched,
  linkPercentageValidationSchema,
  reusableItemValue,
}) => {
  const dispatch = useDispatch();
  const targetRef = useRef(null);
  const allExercises = useSelector((state) => state.calendar.data.allExercises);
  const tagsForAccount = useSelector((state) => state.calendar.data.tagsForAccount);
  const isAccountTagsLoading = useSelector((state) => state.calendar.ui.isAccountTagsLoading);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const accountCode = currentUser?.accountCode;
  const currentUserAccessLevel = currentUser?.organizationAccessLevel;
  const modalData = useSelector((state) => state.calendar.data.modalData);
  const [showTooltip, setShowTooltip] = useState(false);
  const [includeCheckmarkForNoneOption, setIncludeCheckmarkForNoneOption] = useState(true);
  const [isNewTagOptionLoading, setIsNewTagOptionLoading] = useState(false);
  const [showAdditionalOptions, setShowAdditionalOptions] = useState(true);
  const [stateTagOptions, setStateTagOption] = useState(tagsForAccount);
  const [inputValue, setInputValue] = useState(null);

  const validateLinkPercentageAndSetFieldErrorOnChange = async (value) => {
    try {
      await linkPercentageValidationSchema.validate(value);
    } catch (err) {
      setFieldError('name', err.message);
    }
  };

  const handleClickOutside = (event) => {
    if (
      targetRef.current
      && !targetRef.current.contains(event.target)
    ) {
      setShowTooltip(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [targetRef]);

  useEffect(() => {
    /** close tool tip when modal is resizing */
    setShowTooltip(false);
  }, [containerWidth]);

  const linkToOptions = [
    {
      name: 'None',
      id: 'none',
      includeCheckmark: includeCheckmarkForNoneOption,
      checkmarkColor: '#BDBDBD',
    },
    /** for lifts we give the option to link to body weight which is exercise id 1 in all accounts */
    {
      name: 'Body Weight',
      id: 1,
      includeCheckmark: linkToValue === 1,
      checkmarkColor: '#BDBDBD',
    },
    ...allExercises
      .filter((exercise) => exercise.type === 'L' && exercise.track > 0) /** Filter the exercises */
      .map((exercise) => ({
        name: exercise.name,
        id: exercise.id,
        includeCheckmark: linkToValue === exercise?.id,
        checkmarkColor: '#BDBDBD',
      })),
  ];

  const memoizedLinkToOptions = useMemo(() => linkToOptions, [allExercises, includeCheckmarkForNoneOption, linkToValue]);

  /** make sure tags always get put in alphabetically order becuase we can make new tags in the dropdown */
  const memoizedTagOptions = useMemo(() => [...tagsForAccount].sort((a, b) => a.name.localeCompare(b.name)),
    [allExercises, stateTagOptions, tagsValue]);

  const trackingOptions = [
    {
      name: 'Disabled',
      id: 0,
      includeCheckmark: trackingValue === 0,
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Max Weight (1RM)',
      id: 1,
      includeCheckmark: trackingValue === 1,
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Max Weight 3RM',
      id: 3,
      includeCheckmark: trackingValue === 2,
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Highest Entered Weight',
      id: 4,
      includeCheckmark: trackingValue === 3,
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Highest Number of Reps',
      id: 2,
      includeCheckmark: trackingValue === 4,
      checkmarkColor: '#BDBDBD',
    },
  ];

  const AthleteInputCheckBoxDataArray = [
    {
      name: 'completionOnly',
      label: 'Completion Only',
      checked: completionOnlyValue,
    }, {
      name: 'coachCompletion',
      label: 'Coach Completion',
      checked: coachCompletionValue,
    }, {
      name: 'bodyweightLift',
      label: 'Bodyweight (Reps Only)',
      checked: boadyWeightLiftValue,
    },
    {
      name: 'peakPower',
      label: 'Peak Power',
      checked: peakPowerValue,
    },
    {
      name: 'barSpeed',
      // label: 'Bar Speed',
      label: 'Velocity',
      checked: barSpeedValue,
    },
    {
      name: 'eachSide',
      label: 'Each Side (Right and Left)',
      checked: eachSideValue,
    },
  ];

  const InputTypeCheckBoxDataArray = [
    {
      name: 'trackVolumeLoad',
      label: 'Track Volume Load',
      checked: trackVolumeLoadValue,
    }, {
      name: 'trackRepCount',
      label: 'Track Rep Count',
      checked: trackRepCountValue,
    }];

  const customSelectStylesLinkTo = {
    control: (provided, state) => ({
      ...provided,
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 400,
      background: 'white',
      borderColor: state.isFocused ? 'lightgray' : 'lightgray',
      boxShadow: state.isFocused ? 'none' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? 'lightgray' : 'lightgray',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '4px',
      borderRadius: '4px',
      backgroundColor: 'white',
      color: state.isSelected || ((linkToValue === 'none' || linkToValue === null) && state.data.id === 'none') || (trackingValue === 0 && state.data.id === 0) ? '#BDBDBD' : '#444444',
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      marginBottom: '8px',
      fontWeight: state.data.__isNew__ ? 700 : 400,
      '&:hover': {
        backgroundColor: '#FCFCFC',
      },
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: '#FCFCFC',
      border: '1px solid #EEEEEE',
      borderRadius: '4px',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: '#444444',
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: '#9E9E9E',
    }),
    menu: (provided) => ({
      ...provided,
      border: '0px',
      minWidth: '250px',
      padding: '16px',
      marginTop: '0px',
      marginBottom: '0px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9E9E9E',
    }),
    input: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? 'inherit' : provided.color, /** Use 'inherit' to maintain original color */
    }),
  };

  const MenuList = (props) => {
    const { children, maxHeight } = props;
    const listRef = useRef({});
    const rowHeights = useRef({});
    /** Calculate height based on the children length or a default */
    const childrenLengthBy40 = children?.length ? children.length * 40 : 40;
    const height = Math.min(childrenLengthBy40, maxHeight);
    const getRowHeight = (index) => rowHeights.current[index] + 8 || 40;

    return (
      <div style={{ height }}>
        {!children.length ? (
          <List
            ref={listRef}
            height={40}
            itemCount={1}
            itemSize={() => 40}
          >
            {({ style }) => (
              <div style={{
                ...style, display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
              >
                <Text fontSize='16px' color='hsl(0, 0%, 60%)'>No options</Text>
              </div>
            )}
          </List>

        ) : (
          <List
            ref={listRef}
            height={height}
            itemCount={children.length}
            itemSize={(index) => getRowHeight(index)}
          >
            {({ index, style }) => {
              const rowRef = useRef({});

              useEffect(() => {
                if (rowRef.current) {
                  const rowHeight = rowRef.current.getBoundingClientRect().height;
                  /** Store this index's height and reset the List after each update */
                  if (rowHeights.current[index] !== rowHeight) {
                    rowHeights.current[index] = rowHeight;
                    listRef.current?.resetAfterIndex(index); /** Reset from this index to recalculate sizes */
                  }
                }
              }, [index]);

              return (
                <div style={style}>
                  <div ref={rowRef}>
                    {children[index]}
                  </div>
                </div>
              );
            }}
          </List>
        )}
      </div>
    );
  };

  const MemoizedMenuList = React.memo(MenuList);

  return (
    <LiftInputsContainer>
      <LiftInputsRow containerWidth={containerWidth}>
        <VideoAndUrlInput
          errors={errors}
          touched={touched}
          videoUrlValue={videoUrlValue}
          mediaUrlValue={mediaUrlValue}
          setFieldValue={setFieldValue}
          urlButtonValue={urlButtonValue}
          containerWidth={containerWidth}
          setFieldTouched={setFieldTouched}
          setFieldError={setFieldError}
          isDisabled={modalData?.disabledEditModal}
        />
        <LiftInputsSubContainer>
          {/* <NameAndInputContainer disabled={modalData?.disabledEditModal}>
            <input
              disabled={modalData?.disabledEditModal}
              className='checkbox-input'
              type='checkbox'
              name='reusableItem'
              onChange={() => {
                setFieldValue('reusableItem', !reusableItemValue);
              }}
              checked={reusableItemValue}
            />
            <Text color={modalData?.disabledEditModal && '#BDBDBD'} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>Save to Database</Text>
          </NameAndInputContainer> */}
          <SelectBox
            isDisabled={modalData?.disabledEditModal}
            options={trackingOptions}
            value={trackingOptions.find((option) => option.id === trackingValue)}
            onChangeFunction={(option) => {
              setFieldValue('tracking', parseInt(option.id, 10));
            }}
            onBlur={() => setFieldTouched('tracking', true)}
            error={!!touched.tracking && !!errors.tracking}
            errorMsg={errors.tracking}
            title='PR Tracking'
            titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
            customStyles={customSelectStylesLinkTo}
            isClearable={false}
            styledProps={{ height: '' }}
          />
          <OuterLinkContainer>
            <LinkContainer containerWidth={containerWidth}>
              <SelectBox
                isDisabled={modalData?.disabledEditModal}
                closeOnResize
                options={memoizedLinkToOptions}
                value={
                    memoizedLinkToOptions.find((option) => option.id === linkToValue)?.id === 'none'
                      ? null
                      : memoizedLinkToOptions.find((option) => option.id === linkToValue)
                }
                onChangeFunction={(option) => {
                  setIncludeCheckmarkForNoneOption(option.id === 'none');
                  if (option.id === 'none') {
                    setFieldValue('linkTo', 'none');
                    setFieldValue('linkPercentage', null);
                  } else {
                    setFieldValue('linkTo', parseInt(option.id, 10));
                    setFieldValue('linkPercentage', 100);
                  }
                }}
                onBlur={() => setFieldTouched('linkTo', true)}
                error={!!touched.linkTo && !!errors.linkTo}
                errorMsg={errors.linkTo}
                title='Link to'
                titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                customStyles={customSelectStylesLinkTo}
                isClearable={false}
                menuListComponent={MemoizedMenuList}
              />
              {linkToValue && linkToValue !== 'none' && (
              <Input
                disabled={modalData?.disabledEditModal}
                error={!!touched.linkPercentage && !!errors.linkPercentage}
                errorMsg={errors.linkPercentage}
                fontSize='16px'
                fontWeight={400}
                textColor='#444444'
                height='38px'
                top='38px'
                label='Link Percentage (%PR)'
                name='linkPercentage'
                onChange={(value) => {
                  handleChange(value);
                  setTouched({ linkPercentage: true });
                  validateLinkPercentageAndSetFieldErrorOnChange(value);
                }}
                onBlur={handleBlur}
                right='5px'
                styledPropsLabel={{
                  fontSize: '16px',
                  fontWeight: 700,
                }}
                value={linkPercentageValue}
                width='100%'
              />
              )}
            </LinkContainer>
            {linkToValue && linkToValue !== 'none' && (
            <UpdateLinkedMaxContainer>
              <input
                className='checkbox-input'
                type='checkbox'
                name='updateLinkedExerciseMax'
                onChange={() => {
                  if (currentUserAccessLevel < 4) {
                    setShowTooltip(!showTooltip);
                  } else {
                    setFieldValue('updateLinkedExerciseMax', !updateLinkedExerciseMaxValue && true);
                  }
                }}
                checked={currentUserAccessLevel < 4 ? false : updateLinkedExerciseMaxValue}
                ref={targetRef}
              />
              <Text fontSize='16px'>Allow maxes from this exercise to add to/update the linked exercise max</Text>
              {showTooltip && (
                <TBportalTooltip targetRef={targetRef} backgroundColor='#FCFCFC' setShowToolTip={setShowTooltip} closeOnScroll>
                  <Text fontSize='14px' style={{ maxWidth: '150px', textAlign: 'center' }}>Gold or Platnum account required to update</Text>
                </TBportalTooltip>
              )}
            </UpdateLinkedMaxContainer>
            )}
          </OuterLinkContainer>
          <DescriptionContainer>
            <Text
              fontSize='16px'
              fontWeight={700}
              color={modalData?.disabledEditModal && '#BDBDBD'}
            >
              Description
            </Text>
            <Field
              name='description'
              className='form-control'
              render={({ field }) => (
                <StyledTextArea disabled={modalData?.disabledEditModal} {...field} />
              )}
            />
            {errors.description && (
            <Text color='#CC0404' fontSize='13px' fontWeight={700} style={{ marginTop: '5px' }}>{errors.description}</Text>
            )}
          </DescriptionContainer>
          <SelectBox
            isDisabled={isNewTagOptionLoading || isAccountTagsLoading || modalData?.disabledEditModal}
            options={memoizedTagOptions}
            value={tagsValue?.map((tagId) => memoizedTagOptions.find((option) => option.id === tagId)) || []}
            onInputChange={(value) => setInputValue(value)}
            onChangeFunction={(selectedOptions) => {
              /** Extract tag IDs from the selected options */
              const selectedTagIds = selectedOptions.map((option) => option.id);
              /* Update the 'tags' field in the form */
              setFieldValue('tags', selectedTagIds);
            }}
            onBlur={() => setFieldTouched('tags', true)}
            error={!!touched.tags && !!errors.tags}
            errorMsg={errors.tags}
            title='Tag(s)'
            titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
            customStyles={customSelectStylesLinkTo}
            isMulti
            isCreateable
            isLoading={isNewTagOptionLoading || isAccountTagsLoading}
            // isDisabled={isNewTagOptionLoading || isAccountTagsLoading}
            onCreateOption={(option) => {
              setIsNewTagOptionLoading(true);
              dispatch(createTagForAccount(accountCode, option, {
                onSuccess: (response) => {
                  const newOptionReturnedFromApi = { name: response.name, id: response.id };
                  setStateTagOption((prevOptions) => [...prevOptions, newOptionReturnedFromApi]);
                  setFieldValue('tags', [...(tagsValue || []), newOptionReturnedFromApi?.id]);
                  setIsNewTagOptionLoading(false);
                },
                onError: () => {
                  showErrorToast('Opps! Something went wrong. Unable to create new tag.');
                  setIsNewTagOptionLoading(false);
                },
              }));
            }}
            noOptionsMessage={!inputValue ? 'Type to add new tag' : 'No Options'}
            menuListComponent={MemoizedMenuList}
          />
        </LiftInputsSubContainer>
      </LiftInputsRow>
      <AdditionalOptionsHeaderRow>
        <Seperator />
        <AdditionalOptionsTextAndArrowIconContainer onClick={() => setShowAdditionalOptions(!showAdditionalOptions)}>
          <Text fontSize='18px' color='#9E9E9E' style={{ minWidth: '210px' }}>Exercise Default Settings</Text>
          <IcomoonReact
            iconSet={iconSet}
            size={8}
            icon={showAdditionalOptions ? 'up-arrow' : 'down-arrow'}
            color='#9E9E9E'
          />
        </AdditionalOptionsTextAndArrowIconContainer>
        <Seperator />
      </AdditionalOptionsHeaderRow>
      {showAdditionalOptions && (
        <Text fontSize='14px' color='#757575' style={{ marginTop: '-8px' }}>Any items checked below will be active when adding this exercise to a workout</Text>
      )}
      <AdditionalOptionsWrapper showAdditionalOptions={showAdditionalOptions}>
        <LabelAndCheckBoxContainerWrapper showAdditionalOptions={showAdditionalOptions}>
          <CheckBoxRow>
            {AthleteInputCheckBoxDataArray.map((option) => (
              <NameAndInputContainer disabled={modalData?.disabledEditModal} key={option.name} cursorNotAllowed={(completionOnlyValue && option.name === 'bodyweightLift') || (boadyWeightLiftValue && option.name === 'completionOnly')}>
                <input
                  className='checkbox-input'
                  type='checkbox'
                  name={option.name}
                  onChange={() => {
                    setFieldValue(`${option.name}`, !option.checked);
                  }}
                  checked={option.checked}
                  disabled={(completionOnlyValue && option.name === 'bodyweightLift') || (boadyWeightLiftValue && option.name === 'completionOnly') || modalData?.disabledEditModal}
                />
                <Text fontSize='16px' color={modalData?.disabledEditModal && '#BDBDBD'} style={{ whiteSpace: 'nowrap ' }}>{option.label}</Text>
              </NameAndInputContainer>
            ))}
            {InputTypeCheckBoxDataArray.map((option) => (
              <NameAndInputContainer disabled={modalData?.disabledEditModal} key={option.name}>
                <input
                  disabled={modalData?.disabledEditModal}
                  className='checkbox-input'
                  type='checkbox'
                  name={option.name}
                  onChange={() => {
                    setFieldValue(`${option.name}`, !option.checked);
                  }}
                  checked={option.checked}
                />
                <Text fontSize='16px' color={modalData?.disabledEditModal && '#BDBDBD'} style={{ whiteSpace: 'nowrap ' }}>{option.label}</Text>
              </NameAndInputContainer>
            ))}
          </CheckBoxRow>
        </LabelAndCheckBoxContainerWrapper>
      </AdditionalOptionsWrapper>
    </LiftInputsContainer>
  );
};

export default LiftFormInputs;
